import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'

const dtWorkOrdersConfig = dtConfig[ModulesMap.WORK_ORDERS]

function getWorkOrders(companyId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].getWorkOrders,
		{
			urlParams: {
				companyId: companyId,
			},
		}
	)
}

function getWorkOrder(companyId, workOrderId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].getWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
		}
	)
}

function createWorkOrder(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].createWorkOrder,
		{
			urlParams: {
				companyId: companyId,
			},
			...payload,
		}
	)
}

function createFieldWorkOrder(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,
		dtWorkOrdersConfig[ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_FIELD_WORK_ORDER],
		{
			urlParams: {
				companyId: companyId,
			},
			...payload,
		}
	)
}

function putWorkOrder(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].putWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function putCloseFieldWorkOrder(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].putCloseFieldWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function putUpdateFieldWorkOrder(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].putUpdateFieldWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function patchWorkOrder(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].patchWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function patchCloseFieldWorkOrder(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].patchCloseFieldWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function patchUpdateFieldWorkOrder(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].patchUpdateFieldWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function deleteWorkOrder(companyId, workOrderId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].deleteWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
		}
	)
}

function getWorkOrderPreview(companyId, workOrderId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].getWorkOrderPreview,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
		}
	)
}

function getWorkOrderPopup(companyId, workOrderId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].getWorkOrderPopup,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
		}
	)
}

function patchWorkOrderRecalculate(companyId, workOrderId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].patchWorkOrderRecalculate,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
		}
	)
}

function getWorkOrderIsCanBeClosed(companyId, workOrderId) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].getWorkOrderIsCanBeClosed,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
		}
	)
}

function createLogisticWorkOrder(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].createLogisticWorkOrder,
		{
			urlParams: {
				companyId: companyId,
			},
			...payload,
		}
	)
}

function putCloseLogisticWorkOrder(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].putCloseLogisticWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function putUpdateLogisticWorkOrder(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].putUpdateLogisticWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function patchCloseLogisticWorkOrder(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].patchCloseLogisticWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function patchUpdateLogisticWorkOrder(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,dtConfig[ModulesMap.WORK_ORDERS].patchUpdateLogisticWorkOrder,
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
			...payload,
		}
	)
}

function createHandMadeWorkOrder(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,
		dtWorkOrdersConfig[ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_HAND_MADE_WORK_ORDER],
		{
			urlParams: {
				companyId: companyId,
			},
			...payload,
		}
	)
}

function patchHandMadeWorkOrder(companyId, workOrderId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,
		dtWorkOrdersConfig[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_HAND_MADE_WORK_ORDER],
		{
			urlParams: {
				companyId: companyId,
				workOrderId: workOrderId,
			},
			...payload,
		}
	)
}
// PATCH_HAND_MADE_WORK_ORDER

function copyToAnotherBrigade(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,
		dtWorkOrdersConfig[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_BRIGADE],
		{
			urlParams: {
				companyId: companyId,
			},
			...payload,
		}
	)
}

function copyToAnotherPeriod(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,
		dtWorkOrdersConfig[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PERIOD],
		{
			urlParams: {
				companyId: companyId,
			},
			...payload,
		}
	)
}

function copyToAnotherPlanWork(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.WORK_ORDERS,
		dtWorkOrdersConfig[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PLAN_WORK],
		{
			urlParams: {
				companyId: companyId,
			},
			...payload,
		}
	)
}


export default {
	getWorkOrders,
	getWorkOrder,
	createWorkOrder,
	createFieldWorkOrder,
	putWorkOrder,
	putCloseFieldWorkOrder,
	putUpdateFieldWorkOrder,
	patchWorkOrder,
	patchCloseFieldWorkOrder,
	patchUpdateFieldWorkOrder,
	deleteWorkOrder,
	getWorkOrderPreview,
	getWorkOrderPopup,
	patchWorkOrderRecalculate,
	getWorkOrderIsCanBeClosed,
	createLogisticWorkOrder,
	putCloseLogisticWorkOrder,
	putUpdateLogisticWorkOrder,
	patchCloseLogisticWorkOrder,
	patchUpdateLogisticWorkOrder,

	createHandMadeWorkOrder,
	patchHandMadeWorkOrder,

	copyToAnotherBrigade,
	copyToAnotherPeriod,
	copyToAnotherPlanWork,
}

